import React from 'react';
import { PortalLexcoreSnapshotBadge, type PortalLexcoreSnapshotBadgeSize } from './PortalLexcoreSnapshotBadge';
import { PortalJudicatureSnapshotBadge } from './PortalJudicatureSnapshotBadge';

export interface PortalSnapshotStampsProps {
  size?: PortalLexcoreSnapshotBadgeSize;
  interactive?: boolean;
  className?: string;
}

/** LEX-Rechtsstand + OGH-Judikatur-Stempel nebeneinander (keine zwei Inseln). */
export const PortalSnapshotStamps: React.FC<PortalSnapshotStampsProps> = ({
  size = 'sm',
  interactive = false,
  className = '',
}) => (
  <span className={`inline-flex flex-wrap items-center gap-1 min-w-0 ${className}`}>
    <PortalLexcoreSnapshotBadge size={size} interactive={interactive} />
    <PortalJudicatureSnapshotBadge size={size} interactive={interactive} />
  </span>
);
